import { $el, $list, $elParent } from 'src/scripts/utils/utils'
import { ProductForm, VariantPicker } from '.'
import { BaseComponent } from '../../components/base-component'

const ACTIVE_VALUE_SELECTOR = '[data-color-swatches-picker-active-value]'
const LABEL_SELECTOR = '[data-color-swatches-picker-label]'

export class ColorSwatchesPicker extends BaseComponent {
  mountComponent(): void {
    const labels = $list(LABEL_SELECTOR, this)
    const form: ProductForm = (
      $elParent('variant-picker', this) as VariantPicker
    )?.getForm()

    if (form) {
      this.addListener(form, 'change', this.handleFormChange)
    }
    labels.forEach(label => {
      this.addListener(label, 'mouseenter', this.handleMouseEnter)
      this.addListener(label, 'mouseleave', this.handleMouseLeave)
    })
  }

  handleFormChange = (): void => {
    this.setSelected()
  }

  handleMouseEnter = (event: MouseEvent): void => {
    event.preventDefault()

    const target = event.target as HTMLElement

    this.setHovered(target.dataset.value)
  }

  handleMouseLeave = (event: MouseEvent): void => {
    event.preventDefault()
    this.setSelected()
  }

  setSelected(): void {
    const swatch = $el(`${LABEL_SELECTOR}.selected`, this)
    this.setHovered(swatch?.getAttribute('data-value') || '')
  }

  setHovered(value: string): void {
    const label = $el(ACTIVE_VALUE_SELECTOR, this)
    if (label) {
      label.textContent = value
    }
  }
}
